import gql from 'graphql-tag'

/**
 * Query
 */
const GET_ALL = gql`
  query dailyControls($filters: FiltersDailyControl) {
    dailyControls(filters: $filters) {
      id
      employee_id
      employee {
        id
        name
        fullName
        last_name
        mothers_last_name
        email
        phone_number
        document_type
        document_number
        work_start_date
      }
      work_description_id
      workDescription {
        id
        name
      }
      price
      amount
      total
      date
    }
  }
`

const GET_WITH_PAGINATION = gql`
query dailyControlsWithPagination($page: Int, $perPage: Int, $filters: FiltersDailyControl) {
  dailyControlsWithPagination(page: $page, first: $perPage, filters: $filters){
    paginatorInfo {
      currentPage
      count
      hasMorePages
      perPage
      total
    }
    data {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
        fullName
        email
      }
      work_description_id
      workDescription {
        id
        name
      }
      price
      amount
      total
      date
    }
  }
}
`

const GET_TOTALS = gql`
  query getTotalDailyControl ($filters: FiltersDailyControl) {
    getTotalDailyControl(filters: $filters) {
      amountTotal
      countTotal
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createDailyControl ($input: DailyControlForm!) {
    createDailyControl (input: $input) {
      id
    }
  }
`

const UPDATE = gql`
  mutation updateDailyControl ($id: ID!, $input: DailyControlForm!) {
    updateDailyControl (id: $id, input: $input) {
      id
    }
  }
`

const DELETE = gql`
  mutation deleteDailyControl ($id: ID!) {
    deleteDailyControl(id: $id) { 
      id
    }
  }
`

export {
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE,
    GET_ALL,
    GET_TOTALS
}
